import React from "react";

const STATUS_MAP = {
  active: { label: "Active", color: "#10B981", bg: "#10B98114" },
  inactive: { label: "Inactive", color: "#94A3B8", bg: "#94A3B814" },
  locked: { label: "Locked", color: "#EF4444", bg: "#EF444414" },
  discharged: { label: "Discharged", color: "#6366F1", bg: "#6366F114" },
  transferred: { label: "Transferred", color: "#06B6D4", bg: "#06B6D414" },
  approved: { label: "Approved", color: "#10B981", bg: "#10B98114" },
  pending: { label: "Pending", color: "#F59E0B", bg: "#F59E0B14" },
  rejected: { label: "Rejected", color: "#EF4444", bg: "#EF444414" },
  in_progress: { label: "In Progress", color: "#6366F1", bg: "#6366F114" },
  completed: { label: "Completed", color: "#10B981", bg: "#10B98114" },
  critical: { label: "Critical", color: "#EF4444", bg: "#EF444414" },
  warning: { label: "Warning", color: "#F59E0B", bg: "#F59E0B14" },
  info: { label: "Info", color: "#06B6D4", bg: "#06B6D414" },
};

export default function StatusBadge({ status, label, testId }) {
  const key = (status || "").toString().toLowerCase();
  const cfg = STATUS_MAP[key] || { label: label || status || "—", color: "#94A3B8", bg: "#94A3B814" };
  return (
    <span
      data-testid={testId || `status-${key}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium"
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: cfg.color }} />
      {label || cfg.label}
    </span>
  );
}
